module.exports = __webpack_public_path__ + "4417ef791e3bfcbe5ebbe3d565660d05.svg";